import {useCallback, useEffect, useRef} from 'react';
import {resetTutorialDice, setTutorialDiceActive} from './tutorialDice';

/**
 * Фиксированные кости обучения на время партии-главы. Бутстрап главы
 * запускает сессию (возвращаемая функция: очередь с нуля, кости включены),
 * выход из партии глушит кости — вне обучения генератор должен быть честным.
 *
 * Эффект перезапускается и без выхода из партии: Fast Refresh в разработке
 * пересоздает эффекты правленого компонента. Раньше это молча выключало кости
 * до конца главы — сценарий шел на случайных бросках (штурм главы 3 выпадал
 * -3/+1 вместо -3/-2). Поэтому очередь при выключении сохраняется, а повторный
 * запуск эффекта уже начатой сессии включает кости обратно. До старта сессии
 * (двойной запуск эффектов StrictMode при монтировании) кости не включаются.
 */
export const useTutorialDiceSession = (tutorialChapterId) => {
  const isSessionStartedRef = useRef(false);

  useEffect(() => {
    if (!tutorialChapterId) {
      return undefined;
    }
    if (isSessionStartedRef.current) {
      setTutorialDiceActive(true);
    }
    return () => setTutorialDiceActive(false);
  }, [tutorialChapterId]);

  return useCallback(() => {
    resetTutorialDice();
    setTutorialDiceActive(true);
    isSessionStartedRef.current = true;
  }, []);
};
